import { render, staticRenderFns } from "./Gallons.vue?vue&type=template&id=5e5dc33e&scoped=true&"
import script from "./Gallons.vue?vue&type=script&lang=js&"
export * from "./Gallons.vue?vue&type=script&lang=js&"
import style0 from "./Gallons.vue?vue&type=style&index=0&id=5e5dc33e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5dc33e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow,VSwitch})
